import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
    body {
        font-family: Arial, Helvetica, sans-serif;
    }
`

